import React from 'react'
import logo from '../../assets/brand/logo100x100.png'
import { CImage } from '@coreui/react'

export const HeaderComponent = ({ title, size = 'h3' }) => {
  const Tag = size
  return (
    <>
      <div className="text-center mb-4">
        <CImage src={logo} height={100} />
      </div>
      <p className="text-medium-emphasis text-center">
        <strong>Asociación Canales de Maipo</strong>
      </p>

      <Tag className="text-center mb-3">{title}</Tag>
    </>
  )
}
